import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Mail, LinkedinIcon, Award, GraduationCap } from "lucide-react";

const TeamMember2 = () => {
  return (
    <div className="py-8">
      {/* Header */}
      <section className="bg-gradient-to-br from-primary to-accent text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="w-80 h-80 bg-primary-foreground/20 rounded-full mx-auto mb-6 flex items-center justify-center overflow-hidden">
              <img 
                src="/lovable-uploads/a778c5fc-8541-45ca-b01e-77d9584a29e7.png" 
                alt="Sam Hallett"
                className="w-full h-full object-cover"
              />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Sam Hallett</h1>
            <p className="text-xl text-primary-foreground/90 mb-4">
              Chief Investment Officer
            </p>
            <Badge className="bg-primary-foreground text-primary">Multi-Asset Portfolios</Badge>
          </div>
        </div>
      </section>

      {/* Biography */}
      <section className="py-16 bg-background">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h2 className="text-3xl font-bold mb-6">Biography</h2>
              <div className="prose prose-lg text-muted-foreground space-y-4">
                <p>
                  Sam brings comprehensive expertise in investment strategy and portfolio management to his role 
                  as Chief Investment Officer at Cape Berkshire Asset Management. With professional qualifications 
                  from CISI and a strong academic foundation in Finance & Investment Banking, he leads the 
                  development and implementation of our sophisticated model portfolio strategies.
                </p>
                <p>
                  As CIO, Sam oversees all aspects of investment research, asset allocation, and portfolio 
                  construction across our range of model portfolios. His analytical approach combines traditional 
                  investment principles with modern portfolio theory, focusing on risk-adjusted returns and 
                  strategic diversification across multiple asset classes including equities, fixed income, 
                  and alternative investments.
                </p>
                <p>
                  Sam has particular expertise in macroeconomic analysis, enabling him to position portfolios 
                  strategically for changing market conditions. His commitment to continuous research and staying 
                  ahead of market trends ensures our clients benefit from innovative investment solutions designed 
                  to deliver superior long-term outcomes. Sam's leadership of our investment committee ensures 
                  all investment decisions are thoroughly researched and aligned with our clients' objectives.
                </p>
              </div>
            </div>
            
            <div>
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Award className="h-5 w-5" />
                    Qualifications & Expertise
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    <li className="flex items-center">
                      <GraduationCap className="h-4 w-4 text-primary mr-2" />
                      <span className="text-sm">CISI Qualified</span>
                    </li>
                    <li className="flex items-center">
                      <GraduationCap className="h-4 w-4 text-primary mr-2" />
                      <span className="text-sm">BSc Finance & Investment Banking</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
              
              <Card className="mt-6">
                <CardHeader>
                  <CardTitle>Contact</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <Button variant="outline" className="w-full justify-start" asChild>
                      <a href="mailto:sam.hallett@capeberkshire.co.uk">
                        <Mail className="h-4 w-4 mr-2" />
                        Send Message
                      </a>
                    </Button>
                    <Button variant="outline" className="w-full justify-start" asChild>
                      <a 
                        href="https://www.linkedin.com/in/samhallett/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedinIcon className="h-4 w-4 mr-2" />
                        LinkedIn Profile
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-primary-foreground">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Learn About Our Investment Approach?
          </h2>
          <p className="text-xl mb-8 text-primary-foreground/90 max-w-2xl mx-auto">
            Get in touch with Sam and our investment team to discuss our portfolio strategies and approach.
          </p>
          <Button size="lg" variant="secondary" asChild>
            <Link to="/contact">Contact Our Team</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default TeamMember2;